import {Modal} from "antd";
import React, {FC, memo} from "react";
import MarkdownFileReader from "../../../../helpers/markdown/MarkdownFileReader";

type ModifyBookingsDocumentationProps = {asModal?: boolean; open: boolean; onClose: () => void; modalStyle?: React.CSSProperties; modalBodyStyle?: React.CSSProperties};

const ModifyBookingsDocumentation: FC<ModifyBookingsDocumentationProps> = ({asModal, open, onClose, modalStyle, modalBodyStyle}) => {
    const renderContent = () => {
        return (
            <div>
                <MarkdownFileReader filePath="/ModifyBookingsDocumentation.md" />
            </div>
        );
    };

    if (asModal) {
        return (
            <Modal open={open} onCancel={onClose} onOk={onClose} width={800} style={modalStyle} bodyStyle={modalBodyStyle} title="Erklärung zum Anpassen von Einzelbuchungen">
                {renderContent()}
            </Modal>
        );
    }

    return renderContent();
};

export default memo(ModifyBookingsDocumentation);
